import { Plan } from '../../../Templates/Plan';

export function Private({ kernel }) {
    return <Plan endpoint='/plans/private.json' />
}
